import { IAnimal } from 'src/dto/animal.dto'
import { formatWeight } from 'src/utils'
import { v4 as uuidv4 } from 'uuid'

export class Animal implements IAnimal {
  idFazenda!: string
  idAnimal?: string
  sexo!: string
  cdn!: string | null
  processosMangueiro!: string[]
  animalComprado!: boolean

  tela!: string | null
  brinco!: string | null
  raca!: string | null
  sangue!: string | null
  dataNascimento!: string | null
  rgn!: string | null
  rgd!: string | null
  avalGene!: string | null
  nome!: string | null
  dataVenda!: string | null
  idAnimalMae!: string | null
  idAnimalPai!: string | null
  fazendaOrigem!: string | null
  dataMorte!: string | null
  pelagem!: string | null
  imagem!: any | null
  abcz!: string | null

  idLoteAtual!: string | null
  idPastoAtual!: string | null

  nabc!: string | null
  observacoes!: string | null

  pesoAtual!: number | null

  regime!: string | null
  categoria!: string | null
  descricao!: string | null
  consanguinidade!: string | null

  brincoMae!: string | null
  brincoPai!: string | null

  perimetro!: number | null
  fitaPerimetro!: number | null
  fitaComprimento!: number | null

  dataCompra!: string | null
  dataInicio!: string | null
  dataFinal!: string | null
  dataAtual!: string | null

  grau!: string | null
  acao!: string | null

  animalMae!: any | null
  animalPai!: any | null

  cat!: string | null
  var!: string | null

  desmamado!: boolean | null
  externo!: boolean | null

  id?: string

  idFazendaMae!: string | null
  idFazendaPai!: string | null

  idadeNaCompra!: number | null
  idadeNaDesmama!: number | null

  key!: string | null

  pesoAoNascer!: number | null
  pesoCompra!: number | null
  pesoNaDesmama!: number | null

  serie!: string | null
  nascimento!: string | null

  tourosMultiplos!: any

  tipoAnimal!: string | null
  tipoMonta!: string | null

  desc!: string | null

  constructor(params: Partial<IAnimal>) {
    this.idFazenda = params.idFazenda!
    this.idAnimal = params.idAnimal ?? uuidv4()

    this.sexo = params.sexo ?? 'M'
    this.processosMangueiro = params.processosMangueiro ?? []
    this.animalComprado = params.animalComprado ?? false

    this.cdn = this.str(params.cdn) ?? ''
    this.tela = this.str(params.tela)
    this.brinco = this.str(params.brinco)
    this.raca = this.str(params.raca)
    this.sangue = this.str(params.sangue)

    this.dataNascimento = this.str(params.dataNascimento)

    this.rgn = this.str(params.rgn)
    this.rgd = this.str(params.rgd)
    this.avalGene = this.str(params.avalGene)
    this.nome = this.str(params.nome)

    this.dataVenda = this.str(params.dataVenda)

    this.idAnimalMae = this.str(params.idAnimalMae)
    this.idAnimalPai = this.str(params.idAnimalPai)

    this.fazendaOrigem = this.str(params.fazendaOrigem)

    this.dataMorte = this.str(params.dataMorte)

    this.pelagem = this.str(params.pelagem)
    this.imagem = params.imagem ?? null

    this.abcz = this.str(params.abcz)

    this.idLoteAtual = this.str(params.idLoteAtual)
    this.idPastoAtual = this.str(params.idPastoAtual)

    this.nabc = this.str(params.nabc)
    this.observacoes = this.str(params.observacoes)

    this.pesoAtual = this.parsePeso(params.pesoAtual)

    this.regime = this.str(params.regime)
    this.categoria = this.str(params.categoria)
    this.descricao = this.str(params.descricao)

    this.consanguinidade = this.str(params.consanguinidade)

    this.brincoMae = this.str(params.brincoMae)
    this.brincoPai = this.str(params.brincoPai)

    this.perimetro = params.perimetro ?? null
    this.fitaPerimetro = params.fitaPerimetro ?? null
    this.fitaComprimento = params.fitaComprimento ?? null

    this.dataCompra = this.str(params.dataCompra)
    this.dataInicio = this.str(params.dataInicio)
    this.dataFinal = this.str(params.dataFinal)
    this.dataAtual = this.str(params.dataAtual)

    this.grau = this.str(params.grau)
    this.acao = this.str(params.acao)

    this.animalMae = params.animalMae ?? null
    this.animalPai = params.animalPai ?? null

    this.cat = this.str(params.cat)
    this.var = this.str(params.var)

    this.desmamado = params.desmamado ?? null
    this.externo = params.externo ?? null

    this.id = params.id

    this.idFazendaMae = this.str(params.idFazendaMae)
    this.idFazendaPai = this.str(params.idFazendaPai)

    this.idadeNaCompra = params.idadeNaCompra ?? null
    this.idadeNaDesmama = params.idadeNaDesmama ?? null

    this.key = this.str(params.key)

    this.pesoAoNascer = params.pesoAoNascer ?? null
    this.pesoCompra = params.pesoCompra ?? null
    this.pesoNaDesmama = params.pesoNaDesmama ?? null

    this.serie = this.str(params.serie)
    this.nascimento = this.str(params.nascimento)

    this.tourosMultiplos = params.tourosMultiplos ?? null

    this.tipoAnimal = this.str(params.tipoAnimal)
    this.tipoMonta = this.str(params.tipoMonta)

    this.desc = this.str(params.desc)
  }

  private str(value?: string | null) {
    return value ?? null
  }

  private parsePeso(value?: number | string | null): number | null {
    if (value == null) return 0

    if (typeof value === 'string') {
      return parseFloat(formatWeight(value))
    }

    return value
  }
}
